import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message, Popconfirm, Popover, Upload} from 'antd';
import {Route, Switch} from "react-router-dom";

import Create from './create';
import {
    createResource,
    deleteResource,
    fetchResource,
    getResource,
    getResourceForDownload,
    getSearchResource,
    saveResourceQuery,
    removePhoto,
    unlinkResource,
    updateResource,
    uploadPhoto,
} from '../../appRedux/actions/AssetLink';
import {fetchResource as fetchAssetById, getAllAssetType} from '../../appRedux/actions/Asset';

import {checkQrAlreadyUsed, fetchRelationshipSearchData, searchGlobalAssetData} from '../../appRedux/actions/Common';

import {fetchFilter, searchPOInGlobalData, getEquipmentSubTypeByAssetTypes} from "../../appRedux/actions";
import {getAll as getAllTagTypes} from "../../appRedux/actions/AssetTagType";
import {
    faviconDynamicFunction,
    getColumnSearchProps,
    getRenderForFieldByType,
    sanitizeFieldName
} from '../../util/methods';
import * as _ from 'lodash';
import LinkList from "./LinkList";
import ImagePreviewModal from "../../components/ImagePreviewModal";


export class AssetLink extends Component {
    initialQueryState = {
        sort: {
            field: '',
            order: ''
        },
        pagination: {
            pageSize: 10,
            current: 1
        },
        filters: {},
    };

    state = {
        fields: {
            name: {
                value: '',
            },
            description: {
                value: ''
            }
        },
        query: this.initialQueryState,
        columns: [],
        visibleColumns: [],
        photoPreview: { visible: false, index: 0, photos: [] }
    };

    constructor(props) {
        super(props);
        props.saveResourceQuery(this.initialQueryState);
    }

    openPhotoPreview = (photos, index) => {
        const list = (photos || [])
            .filter((p) => p && p.url)
            .map((p, i) => ({ url: p.url, name: p.name || `Photo ${i + 1}` }));
        this.setState({ photoPreview: { visible: true, index, photos: list } });
    };

    closePhotoPreview = () => {
        this.setState((prev) => ({ photoPreview: { ...prev.photoPreview, visible: false } }));
    };

    componentDidMount() {
        // this.fetchList();
        this.props.fetchFilter(this.props.resourceName);
        // this.props.getAllTagTypes(); // execute in linker
        // console.log(this.props.match.params)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
            const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column) || filter === 'photos' || filter === 'scannerData');
            this.setState({visibleColumns: columns}, () => {
                this.renderColumns(nextProps.filters, this.state.visibleColumns);
            })
        }
    }

    handleColumnChange = (value, array) => {
        const {filters} = this.props;
        this.renderColumns(filters, value);
    };

    handleFilter = (selectedKeys, confirm, data) => {
        const query = {...this.props.query};
        query.filters[data.field] = JSON.stringify({
            value: selectedKeys,
            type: data.type,
            field: data.field
        });
        this.props.saveResourceQuery(query);
        confirm();
        this.fetchList();
    };

    handleAsseList = (selectedKeys, data) => {
        // console.log(selectedKeys, data);
        const query = {filters: []};
        // console.log(query)
        query.filters[data.field] = JSON.stringify({
            value: selectedKeys,
            type: data.type,
            field: data.field
        });
        this.props.saveResourceQuery(query);
        // confirm();
        this.fetchList();
    };

    handleReset = (clearFilters, data) => {
        const query = {...this.props.query};
        delete query.filters[data.field];
        this.props.saveResourceQuery(query);
        clearFilters();
        this.fetchList();
    };

    handleChange = (pagination, filters, sorter) => {
        const query = {...this.props.query};
        query.pagination = {...query.pagination, current: pagination.current};
        query.sort = sorter;
        this.props.saveResourceQuery(query);
        this.fetchList();
    };

    handleFormChange = (changedFields) => {
        this.setState(({fields}) => ({
            fields: {...fields, ...changedFields},
        }));
    };

    validatePhotoUpload = (file) => {
        const isImage = file && file.type && file.type.startsWith('image/');
        if (!isImage) {
            message.error('You can only upload image files!');
            return false;
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            message.error('Image must be smaller than 10MB!');
            return false;
        }
        return true;
    };

    handlePhotoUpload = async (record, file, onSuccess, onError) => {
        if (!record || !record._id) {
            const err = new Error('Tagging record not found');
            message.error(err.message);
            if (onError) {
                onError(err);
            }
            return;
        }
        try {
            await this.props.uploadPhoto(record._id, file);
            if (onSuccess) {
                onSuccess('ok');
            }
        } catch (e) {
            if (onError) {
                onError(e);
            }
        }
    };

    handleUnlink = async (record) => {
        if (!record || !record._id) {
            message.error('Invalid tagging record');
            return;
        }
        await this.props.unlinkResource(record._id);
    };

    handlePhotoDelete = async (record, photo) => {
        if (!record || !record._id) {
            message.error('Invalid tagging record');
            return;
        }
        const photoUrl = (photo && photo.url) || '';
        if (!photoUrl) {
            message.error('Invalid photo');
            return;
        }
        await this.props.removePhoto(record._id, photoUrl);
    };


    renderColumns = (filters, selectedColumns) => {
        filters = filters || this.props.filters;
        const columns = [];
        const {resourceName} = this.props;
        const hasRfidAttribute = (scanner = {}) => {
            const tagTypeRef = scanner.tag_type || scanner.tagType_id || {};
            const attributes = Array.isArray(tagTypeRef.attributes) ? tagTypeRef.attributes : [];
            return attributes.some((attributeName) => ((attributeName || '') + '').trim().toLowerCase() === 'rfid');
        };
        // console.log(filters)
        // console.log(selectedColumns)
        Object.keys(filters).forEach((item) => {

            if (item === '_id') {
                return;
            }

            if (selectedColumns.indexOf(item) === -1) {
                return;
            }
            // console.log(item)
            if (item === 'photos') {
                columns.push({
                    title: sanitizeFieldName(item),
                    dataIndex: filters[item].field,
                    render: (value, record) => {
                        return (
                            <div>
                                <div style={{display: 'flex', flexWrap: 'wrap', gap: 6}}>
                                    {(value || []).map((photo, i) => (
                                        <div key={(photo && photo.url) || (photo && photo.name) || i} style={{position: 'relative'}}>
                                            <img
                                                src={photo.url}
                                                alt={photo.name || `Photo ${i + 1}`}
                                                title={photo.name || `Photo ${i + 1}`}
                                                onClick={() => this.openPhotoPreview(value, i)}
                                                style={{
                                                    width: 48,
                                                    height: 48,
                                                    objectFit: 'cover',
                                                    borderRadius: 4,
                                                    border: '1px solid #d9d9d9',
                                                    cursor: 'pointer',
                                                }}
                                            />
                                            <Popconfirm
                                                title="Delete this photo?"
                                                onConfirm={() => this.handlePhotoDelete(record, photo)}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button
                                                    type="link"
                                                    size="small"
                                                    icon="delete"
                                                    style={{
                                                        position: 'absolute',
                                                        top: -8,
                                                        right: -8,
                                                        color: '#ff4d4f',
                                                    }}
                                                />
                                            </Popconfirm>
                                        </div>
                                    ))}
                                </div>
                                <div style={{marginTop: 4}}>
                                    <Upload
                                        accept="image/*"
                                        showUploadList={false}
                                        beforeUpload={this.validatePhotoUpload}
                                        customRequest={({file, onSuccess, onError}) =>
                                            this.handlePhotoUpload(record, file, onSuccess, onError)
                                        }
                                    >
                                        <Button size="small" icon="upload" disabled={!record || !record._id}>
                                            Upload
                                        </Button>
                                    </Upload>
                                </div>
                            </div>
                        );
                    },
                })
            } else if (item === 'scannerData') {
                columns.push({
                    title: 'QR ID',
                    dataIndex: filters[item].field,
                    key: 'qr',
                    render: (value) => {
                        return (value || []).map((data, i) => data && data.type && data.id ?
                            <span key={data.id}>{data.type}#{data.id}</span> : null)
                    },
                })
                columns.push({
                    title: 'Tag Type',
                    dataIndex: filters[item].field,
                    render: (value) => {
                        return (value || []).map((data, i) => data && data.tag_type &&
                            <span key={data.id + '_tag'}>{data.tag_type.name || ''}</span> || 'X')
                    },
                })
                columns.push({
                    title: 'RFID No',
                    dataIndex: filters[item].field,
                    render: (value) => {
                        return (value || []).map((data, i) => data && Number.isFinite(data.rfid_no) ?
                            <span key={`${data.id || 'rfid'}_${i}_rfid_no`}>{data.rfid_no}</span> : null)
                    },
                })
            } else {
                columns.push({
                    title: sanitizeFieldName(item),
                    dataIndex: filters[item].field,
                    sorter: true,
                    render: (value) => getRenderForFieldByType(value, filters[item].type, item),
                    ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
                })
            }
        });

        columns.push({
            title: 'Action',
            key: 'action',
            render: (_, record) => {
                const scannerData = (record && record.scannerData) || [];
                const activeQr = scannerData.find(scanner => scanner && scanner.type === 'QR' && scanner.id && scanner.isUnlinked !== true);
                if (!activeQr) {
                    const unlinkedQr = scannerData.find(scanner => scanner && scanner.type === 'QR' && scanner.isUnlinked === true);
                    if (!unlinkedQr) {
                        return <span>Unlinked</span>;
                    }
                    const unlinkedAt = unlinkedQr.unlinkedAt ? new Date(unlinkedQr.unlinkedAt).toLocaleString() : '-';
                    const unlinkedByName = (unlinkedQr.unlinkedBy && unlinkedQr.unlinkedBy.name) || (unlinkedQr.unlinkedBy && unlinkedQr.unlinkedBy.email) || '-';
                    return (
                        <span>
                            Unlinked&nbsp;
                            <Popover
                                title="Unlink Info"
                                content={
                                    <div>
                                        <div><b>When:</b> {unlinkedAt}</div>
                                        <div><b>By:</b> {unlinkedByName}</div>
                                    </div>
                                }
                                trigger="click"
                            >
                                <Button size="small" shape="circle" icon="info-circle" />
                            </Popover>
                        </span>
                    );
                }
                if (!hasRfidAttribute(activeQr)) {
                    return <span>-</span>;
                }
                return (
                    <Popconfirm
                        title="Are you sure you want to unlink this QR?"
                        onConfirm={() => this.handleUnlink(record)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="danger" size="small">Unlink</Button>
                    </Popconfirm>
                );
            },
        });

        this.setState({
            visibleColumns: selectedColumns,
            columns
        })
    };

    clearAll = () => {
        const clearQueryState = {
            sort: {
                field: '',
                order: ''
            },
            pagination: {
                pageSize: 10,
                current: 1
            },
            filters: {},
        };
        //this.props.saveResourceQuery(this.initialQueryState);
        this.props.saveResourceQuery(clearQueryState);
        this.fetchList();
        window.location.reload(false);
    };

    fetchList = () => {
        this.props.getResource();
    };

    createResource = (values) => {
        this.props.createResource(values);
    };

    updateResource = (values, id) => {
        this.props.updateResource(values, id);
    };

    deleteResource = (id) => {
        this.props.deleteResource(id);
    };

    cancelDelete = () => {
        message.error('Cancelled')
    };

    create = () => {
        const {match} = this.props;
        this.props.history.push(`${match.url}/add`);
    };

    edit = (id) => {
        const {match} = this.props;
        this.props.history.push(`${match.url}/edit/${id}`);
    };

    downloadToCSV = () => {
        const columns = [];
        this.state.columns.map(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
        this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "AssetLink");
    }

    render() {
        const {
            match,
            data,
            resource,
            edit,
            fetchResource,
            loading,
            filters,
            modules,
            authUser,
            resourceName,
            width
        } = this.props;
        const {columns, visibleColumns} = this.state;
        faviconDynamicFunction(authUser);
        return (<div>
            {/*<h2>{sanitizeFieldName(resourceName)}</h2>*/}
            <Switch>
                <Route path={`${match.url}/list/:asset?`}
                       render={(props) => <LinkList columns={columns}
                           // visibleColumn={visibleColumns}
                                                    data={data}
                           // getResource={this.props.getResource}
                           // clearFilter={this.clearAll}
                                                    filters={filters}
                                                    handleSearch={this.handleAsseList}
                           // columnChange={this.handleColumnChange}
                                                    downloadToCSV={this.downloadToCSV}
                           // title={resourceName}
                           // size={'middle'}
                           // create={this.create}
                           // pagination={this.props.query.pagination}
                                                    loading={loading}
                                                    authUser={authUser}
                                                    {...props}
                       />
                       }/>
                <Route path={`${match.url}/:po?/:poCode?`} exact
                       render={(props) => <Create
                           data={this.props.searchedData}
                           filters={filters}
                           modules={modules}
                           title={'CREATE'}
                           resource={resourceName}
                           authUser={authUser}
                           onChange={this.handleFormChange}
                           onSubmit={this.props.getSearchResource}
                           createLink={this.createResource}
                           loading={loading}
                           linkStatus={this.props.linkStatus}
                           width={width}
                           qrUsed={this.props.qrUsed}
                           checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
                           fetchAssetById={this.props.fetchAssetById}
                           paramAsset={this.props.paramAsset}
                           poSearch={this.props.searchPOInGlobalData}
                           poSearchData={this.props.poSearchData}
                           allTagTypes={this.props.allTagTypes}
                           getAllTagTypes={this.props.getAllTagTypes}
                           getAllAssetType={this.props.getAllAssetType}
                           assetTypes={this.props.assetTypes}
                           getEquipmentSubTypeByAssetTypes={this.props.getEquipmentSubTypeByAssetTypes}
                           equipmentSubTypes={this.props.equipmentSubTypes}
                           fetchRelationshipSearchData={this.props.fetchRelationshipSearchData}
                           assetData={this.props.assetData}
                           assetSearchData={this.props.assetSearchData}
                           assetSearchLoading={this.props.assetSearchLoading}
                           searchGlobalAssetData={this.props.searchGlobalAssetData}
                           {...props}
                       />
                       }/>
                {/*<Route path={`${match.url}/edit/:id`}*/}
                {/*       render={(props) => <Create data={edit}*/}
                {/*                                  filters={filters}*/}
                {/*                                  modules={modules}*/}
                {/*                                  title={'EDIT'}*/}
                {/*                                  resource={resourceName}*/}
                {/*                                  fetch={fetchResource}*/}
                {/*                                  onChange={this.handleFormChange}*/}
                {/*                                  onSubmit={this.updateResource}*/}
                {/*                                  loading={loading}*/}
                {/*                                  {...props}*/}
                {/*       />*/}
                {/*       }/>*/}
            </Switch>
            <ImagePreviewModal
                visible={this.state.photoPreview.visible}
                photos={this.state.photoPreview.photos}
                initialIndex={this.state.photoPreview.index}
                onClose={this.closePhotoPreview}
            />
        </div>)
    }

}

const mapStateToProps = ({auth, assetLink, commonData, settings, purchaseOrder, asset, assetTagType}) => {
    return {
        width: settings.width,
        authUser: auth.authUser,
        total: assetLink.total,
        data: assetLink.resources,
        searchedData: assetLink.searchResources,
        resource: assetLink.resource,
        edit: assetLink.edit,
        query: assetLink.query,
        loading: commonData.loading,
        filters: commonData.filters,
        modules: commonData.modules,
        qrUsed: commonData.qrUsed,
        linkStatus: assetLink.linkStatus,
        paramAsset: asset.edit,
        poSearchData: purchaseOrder.poSearchData,
        allTagTypes: assetTagType.allTypes,
        assetTypes: asset.assetTypes,
        equipmentSubTypes: asset.equipmentSubTypes,
        assetData: commonData.relationshipSearch,
        assetSearchData: commonData.assetSearchData,
        assetSearchLoading: commonData.assetSearchLoading,
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getResource,
        getSearchResource,
        getResourceForDownload,
        createResource,
        fetchResource,
        updateResource,
        deleteResource,
        uploadPhoto,
        removePhoto,
        unlinkResource,
        saveResourceQuery,
        fetchFilter,
        checkQrAlreadyUsed,
        fetchAssetById,
        searchPOInGlobalData,
        getAllTagTypes,
        getAllAssetType,
        getEquipmentSubTypeByAssetTypes,
        fetchRelationshipSearchData,
        searchGlobalAssetData,
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(AssetLink);
